<template>
  <v-row>
    <v-col cols="12" class="ledger">
      <v-card class="rounded-lg white">
        <v-card-title class="secondary--text">{{ title }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3">
              <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  class="rounded-lg"
                  v-model="ledger.level"
                  label="سطح حساب"
                  :items="accountLevels"
                  item-text="text"
                  item-value="value"
                  :return-object="false"
              />
            </v-col>
            <v-col cols="12" :md="(ledger.level == 'floatAccountGroups' && ledger.account)?4:6">
              <account-select
                  label="حساب"
                  v-if="ledger.level != undefined"
                  :items-type="ledger.level"
                  v-model="ledger.account"
                  :floatAccount1.sync="ledger.floatAccount1"
                  :floatAccount2.sync="ledger.floatAccount2"
                  :floatAccount3.sync="ledger.floatAccount3"
                  :floatAccount4.sync="ledger.floatAccount4"
              />
            </v-col>
            <v-col cols="12" md="2" v-if="ledger.level == 'floatAccountGroups' && ledger.account">
              <account-select
                  class="rounded-lg"
                  label="شناور"
                  :childOf="ledger.account.id"
                  v-model="ledger.floatAccount"
                  items-type="floatAccounts"
                  :return-object="false"
                  clearable
              />
            </v-col>
            <template v-if="ledger.account">
              <v-col cols="12" md="3" v-if="!isXs">
                <v-radio-group v-model="filters.order_sanads_by" row>
                  <template #label>مرتب سازی بر اساس:</template>
                  <span>
                    <v-radio label="تاریخ سند" value="date"/>
                    <v-radio label="شماره سند" value="code"/>
                  </span>
                </v-radio-group>
              </v-col>

              <v-col cols="6" md="2">
                <v-select
                    :menu-props="{ bottom: true, offsetY: true }"
                    class="rounded-lg"
                    label="از ماه"
                    v-model="filters.sanad__date__gte"
                    item-text="title"
                    item-value="start"
                    :items="month_items"
                    :return-object="false"
                    clearable
                />
              </v-col>
              <v-col cols="6" md="2">
                <v-select
                    :menu-props="{ bottom: true, offsetY: true }"
                    class="rounded-lg"
                    label="تا ماه"
                    v-model="filters.sanad__date__lte"
                    :items="month_items"
                    item-text="title"
                    item-value="end"
                    :return-object="false"
                    clearable
                />
              </v-col>
              <v-col cols="6" md="2">
                <date label="از تاریخ" v-model="filters.sanad__date__gte" clearable/>
              </v-col>
              <v-col cols="6" md="2">
                <date label="تا تاریخ" v-model="filters.sanad__date__lte" clearable/>
              </v-col>
              <v-col cols="6" md="2">
                <money label="از شماره" v-model="filters.sanad__code__gte" clearable/>
              </v-col>
              <v-col cols="6" md="2">
                <money label="تا شماره" v-model="filters.sanad__code__lte" clearable/>
              </v-col>
              <v-col cols="12">
                <sanad-item-list-report
                    :filter-row="!isXs"
                    :filters.sync="filters"
                    :showAccountInTable="showAccountInTable"
                    :sortable="false"
                    :filterable="!isXs"
                    :show-sum="true"
                    :showRemain="true"
                    :showPreviousRemain="true"
                    :showLink="true"
                />
              </v-col>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SanadItemListReport from "@/components/mcomponents/report/SanadItemListReport";
import queryBinding from "@/components/m-query-binding";
import AccountMixin from "@/mixin/accountMixin";
import {flatMap} from "lodash";

export default {
  name: "Ledger",
  mixins: [queryBinding, AccountMixin],
  components: {SanadItemListReport},
  props: {
    ledgerAccountIds: {
      default: () => [],
    },
    level: {
      default: null,
    },
  },
  data() {
    return {
      month_items: [],
      apiData: {
        results: [],
      },
      ledger: {
        level: this.level,
        account: null,
        floatAccount1: null,
        floatAccount2: null,
        floatAccount3: null,
        floatAccount4: null,
        floatAccountGroup: null,
      },
      filters: {},
      accountLevels: [
        {value: "level0", text: "گروه"},
        {value: "level1", text: "کل"},
        {value: "level2", text: "معین"},
        {value: "level3", text: "تفضیلی"},
        {value: "floatAccountGroups", text: "گروه شناور"},
        {value: "floatAccounts", text: "شناور"},
      ],
    };
  },
  mounted() {
    this.month_items = this.getFinancialYearMonths()
  },
  computed: {
    title() {
      let display = {
        "level0": "گروه" ,
        "level1": "کل" ,
        "level2": "معین" ,
        "level3": "تفضیلی" ,
        "floatAccountGroups": "گروه شناور" ,
        "floatAccounts": "شناور" ,
      }
      return this.setDocumentTitle("گردش حساب " + display[this.ledger.level])
    },
    showAccountInTable() {
      return this.ledger.level != "level3";
    },
  },
  created() {
    this.filters = this.getFiltersTemplate();
    this.init();
  },
  watch: {
    level() {
      this.ledger.level = this.level;
    },
    "ledger.level"() {
      this.filters = this.getFiltersTemplate();
      this.ledger.account =
          this.ledger.floatAccountGroup =
              this.ledger.floatAccount1 =
                  this.ledger.floatAccount2 =
                      this.ledger.floatAccount3 =
                          this.ledger.floatAccount4 =
                              null;
    },
    "ledger.account"() {
      if (this.ledger.account) {
        this.filters.account_title = this.ledger.account.title || this.ledger.account.name;
      }

      if (this.ledger.level.includes("level")) {
        this.filters.account__code__startswith = this.ledger.account ? this.ledger.account.code : null;
      } else {
        this.filters.account__code__startswith = null;
        let filterKeys = {
          floatAccountGroups: "floatAccountGroup",
          floatAccounts: "floatAccount",
        };

        this.filters.account__floatAccountGroup = null;
        this.filters.floatAccount = null;

        Object.values(filterKeys).forEach((filterKey) => {
          this.filters[filterKey] = null;
        });

        this.filters[filterKeys[this.ledger.level]] = this.ledger.account ? this.ledger.account.id : null;
      }
    },
    "ledger.floatAccount1"() {
      this.updateFloatAccountFilter(1);
    },
    "ledger.floatAccount2"() {
      this.updateFloatAccountFilter(2);
    },
    "ledger.floatAccount3"() {
      this.updateFloatAccountFilter(3);
    },
    "ledger.floatAccount4"() {
      this.updateFloatAccountFilter(4);
    },
    "ledger.floatAccount"() {
      this.filters.floatAccount = this.ledger.floatAccount ? this.ledger.floatAccount.id : null;
    },
  },
  methods: {
    getFiltersTemplate() {
      return {
        financial_year: this.financialYear.id,
        account_title: "",
        float_account1_title: "",
        float_account2_title: "",
        float_account3_title: "",
        float_account4_title: "",
        account__code__startswith: "",
        order_sanads_by: "date",
        floatAccount1: null,
        floatAccount2: null,
        floatAccount3: null,
        floatAccount4: null,
        floatAccount__floatAccountGroups: null,
        title: this.title,
        consider_previous_remain: "true",
        floatAccount: null,
        floatAccountGroup: null,
      };
    },
    init() {
      if (typeof this.ledgerAccountIds == "string") {
        let acc = this.findAccount("id", +this.ledgerAccountIds);
      } else {
        for (const id of this.ledgerAccountIds) {
          let acc = this.findAccount("id", id);
          if (!acc) {
            console.error("There is no code ");
            return;
          }
        }
      }
    },
    updateFloatAccountFilter(floatAccountLevel) {
      const key = `floatAccount${floatAccountLevel}`;
      const titleKey = `float_account${floatAccountLevel}_title`;
      const floatAccount = this.ledger[key];

      this.filters[key] = floatAccount ? floatAccount.id : null;
      if (floatAccount) {
        this.filters[titleKey] = floatAccount.title || floatAccount.name;
      } else {
        this.filters[titleKey] = "";
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
